export default __webpack_public_path__ + "static/media/Kaloyan.2ef9e1d3.png";